<template>
  <div class="col-12 col-sm-8 col-xl-9 vh-100 py-4 pr-0">
    <div class="h-100 roleList">
      <ul class="row pl-3 w-100 m-0">
        <li class="col-sm-6 col-xl-2 mb-4" v-for="(item, index) in BusinessRoles" :key="index">
          <div class="card bg-navy off-white">
            <div class="card-body p-2">
              <div class="card-title">
                <div class="media">
                  <div class="w-75 mr-2 mr-lg-3 d-none d-sm-block bg-off-white">
                    <p
                      class="h-100 brown display-2 d-flex justify-content-center align-items-center"
                    >{{ item.BusinessRoleName.substring(0,1) }}</p>
                  </div>
                  <div class="media-body">
                    <ul class="p-0 m-0 d-sm-block d-flex justify-content-around">
                      <li class="h2 mb-4 m-xl-0 roleCancel" @click="delRole(index,item)">
                        <i class="las la-user-times"></i>
                      </li>
                      <li class="h2 mb-4 m-xl-0">
                        <router-link :to="{ name: 'RolePeriod', params: { roleId: item.Id }}"><i class="las la-user-edit off-white"></i></router-link>
                      </li>
                      <li class="h2 mb-4 mb-sm-2 pb-0 pb-sm-3 pb-xl-0 m-xl-0 separate" @click="sendAddOrEditRole(item)">
                        <i class="las la-user-check"></i>
                      </li>
                      <li class="h2 mt-sm-4 m-xl-0 mt-xl-1" @click="authority(index,'Manager')">
                        <i
                          class="las la-user-tie"
                          :class="{'brown':item.BusinessRoleAuthority ==='Manager'}"
                        ></i>
                      </li>
                      <li class="h2 m-xl-0" @click="authority(index,'Normal')">
                        <i
                          class="las la-user"
                          :class="{'brown':item.BusinessRoleAuthority ==='Normal'}"
                        ></i>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="roleName" class="col-sm col-form-label pr-0">名稱</label>
                <div class="col-sm-8 pl-auto pl-sm-0">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    :id="'roleName'+index"
                    :value="item.BusinessRoleName"
                    @input="updateMessage(index,'name')"
                    :placeholder="item.BusinessRoleName"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="roleMail" class="col-sm col-form-label pr-0">Email</label>
                <div class="col-sm-8 pl-auto pl-sm-0">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    :id="'roleMail'+index"
                    :value="item.Email"
                    @input="updateMessage(index,'mail')"
                    :placeholder="item.Email"
                  />
                </div>
              </div>
            </div>
          </div>
        </li>
        <li class="col-sm-6 col-xl-2 mb-4 addRoleBtn" @click="addRole">
          <div class="card bg-navy h-100 off-white py-2 py-sm-0 addRoleItem">
            <i class="las la-user-plus m-auto"></i>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  created () {
    this.$store.dispatch('BusinessUser')
  },
  data () {
    return {
      name: '',
      Email: ''
    }
  },
  computed: {
    BusinessRoles () {
      return this.$store.state.getRoleList
    }
  },
  methods: {
    addRole () {
      const role = {
        BusinessRoleAuthority: 'Normal',
        BusinessRoleName: '',
        BusinessUserId: this.$store.state.BusinessUser.Id,
        Email: '',
        firstTime: true
      }
      var [...list] = this.$store.state.getRoleList
      list.push(role)
      this.$store.commit('RoleList', list)
    },
    delRole (index, item) {
      const vm = this
      this.$swal({
        icon: 'warning',
        title: `是否刪除${item.BusinessRoleName} ?`,
        text: '刪除後將無法還原!',
        showCancelButton: true,
        confirmButtonColor: '#B8817D',
        cancelButtonColor: '#545871',
        confirmButtonText: '是的,刪除吧!'
      }).then(result => {
        if (result.value) {
          var [...list] = this.$store.state.getRoleList
          list.splice(index, 1)
          this.$store.commit('RoleList', list)
          if (item.Id) {
            const url = 'http://imrebooksystem.rocket-coding.com/BusinessRoles/DeleteRole'
            this.axios
              .post(url, { Id: item.Id })
              .then(function (res) {
                if (res.data === '刪除成功') {
                  vm.$swal({
                    position: 'top-end',
                    background: '#F7ECEB',
                    icon: 'success',
                    title: '刪除成功',
                    showConfirmButton: false,
                    toast: true,
                    timer: 3000,
                    timerProgressBar: true,
                    onOpen: toast => {
                      toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                      toast.addEventListener(
                        'mouseleave',
                        vm.$swal.resumeTimer
                      )
                    }
                  })
                } else {
                  vm.$swal({
                    position: 'top-end',
                    background: '#F7ECEB',
                    icon: 'error',
                    title: res.data,
                    showConfirmButton: false,
                    toast: true,
                    timer: 3000,
                    timerProgressBar: true,
                    onOpen: toast => {
                      toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                      toast.addEventListener(
                        'mouseleave',
                        vm.$swal.resumeTimer
                      )
                    }
                  })
                }
              })
              .catch(error => console.error(error))
          }
        }
      })
    },
    sendAddOrEditRole (item) {
      const vm = this
      if (item.Id) {
        const url = 'http://imrebooksystem.rocket-coding.com/BusinessRoles/EditRole'
        this.axios
          .post(url, {
            Id: item.Id,
            BusinessRoleAuthority: item.BusinessRoleAuthority,
            Email: item.Email,
            BusinessRoleName: item.BusinessRoleName
          })
          .then(function (res) {
            if (res.data === '修改成功') {
              vm.$swal({
                position: 'top-end',
                background: '#F7ECEB',
                icon: 'success',
                title: '修改成功',
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
                onOpen: toast => {
                  toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                  toast.addEventListener(
                    'mouseleave',
                    vm.$swal.resumeTimer
                  )
                }
              })
            } else {
              vm.$swal({
                position: 'top-end',
                background: '#F7ECEB',
                icon: 'error',
                title: res.data,
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
                onOpen: toast => {
                  toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                  toast.addEventListener(
                    'mouseleave',
                    vm.$swal.resumeTimer
                  )
                }
              })
            }
          })
          .catch(error => console.error(error))
      } else {
        const url = 'http://imrebooksystem.rocket-coding.com/BusinessRoles/Create'
        this.axios
          .post(url, {
            BusinessUserId: vm.$store.state.BusinessUser.Id,
            BusinessRoleAuthority: item.BusinessRoleAuthority,
            Email: item.Email,
            BusinessRoleName: item.BusinessRoleName
          })
          .then(function (res) {
            if (res.data === '新增成功') {
              vm.$swal({
                position: 'top-end',
                background: '#F7ECEB',
                icon: 'success',
                title: '新增成功',
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
                onOpen: toast => {
                  toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                  toast.addEventListener(
                    'mouseleave',
                    vm.$swal.resumeTimer
                  )
                }
              })
            } else {
              vm.$swal({
                position: 'top-end',
                background: '#F7ECEB',
                icon: 'error',
                title: res.data,
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
                onOpen: toast => {
                  toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                  toast.addEventListener(
                    'mouseleave',
                    vm.$swal.resumeTimer
                  )
                }
              })
            }
          })
          .catch(error => console.error(error))
      }
    },
    authority (index, str) {
      this.$store.commit('updatePermissions', { index, str })
    },
    updateMessage (index, str) {
      const message = event.target.value
      this.$store.commit('updateRoleData', { message, index, str })
    }
  }
}
</script>

<style lang="scss" scoped>
.bg-off-white {
  background-color: #dadbe6;
  height: 190px;
  border-radius: 10px;
}
.roleList {
  overflow-y: auto;
}
.la-user-plus {
  font-size: 2rem;
  transition: 1s;
}
.addRoleItem:hover .la-user-plus {
  transform: scale(1.8);
  transition: 1s;
}
.addRoleItem:active {
  box-shadow: none !important;
  transition: 0.5s;
  transform: translateX(225px);
}
.addRoleBtn {
  min-height: 133px;
}
.separate {
  border-bottom: 1px solid;
}
.las:hover{
  color: #88888b;
  transition: .5s;
}
@media (max-width: 1200px) {
  .la-user-plus {
    font-size: 3rem;
  }
  .bg-off-white {
    height: 290px;
  }
}
@media (max-width: 576px) {
  .card-title {
    height: 25px;
  }
  .la-user-plus {
    font-size: 2rem;
  }
  .separate {
    border-bottom: 0px;
    padding-right: 10px;
    border-right: 1px solid;
  }
}
</style>
